import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import {
  PropertyImagesResponse,
  UpdatePropertyImagesPayload,
  updatePropertyImages,
} from '~/services/AccommodationService';

import { propertyImagesQueryKeys } from './useGetPropertyImages';

export function useUpdatePropertyImages() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ propertyId, images }: { propertyId: string } & UpdatePropertyImagesPayload) => {
      const response = await updatePropertyImages({ propertyId, images });
      return response.result;
    },
    onSuccess: (result, variables) => {
      queryClient.setQueryData<PropertyImagesResponse>(propertyImagesQueryKeys.detail(variables.propertyId), result);
      enqueueSnackbar('Property images updated', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to update property images: ${error.message}`, { variant: 'error' });
    },
  });
}
